import React from 'react';

const AppContext  = React.createContext("{clip: []}");

export default AppContext;
